import React from 'react';
import Modal from 'react-bootstrap/Modal';

const Modaal = ({
    show,
    onHide,
    size,
    centered,
    className,
    backdrop,
    title,
    bodyContent,
    bodyContent1,
    footer,
    scrollable

}) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            size={size}
            aria-labelledby="contained-modal-title-vcenter"
            centered={centered}
            className={className}
            backdrop={backdrop}
            scrollable={scrollable}
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    {title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {bodyContent}
                {bodyContent1}
            </Modal.Body>
            <Modal.Footer>
                {footer}
            </Modal.Footer>
        </Modal>
    );
}

export default Modaal;
